module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "containerW"
    }
  }, [_c('section', [_vm._m(0), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))])]), _c('div', {
    staticClass: "mb-5"
  }), _c('section', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("wirforce")]), _c('div', {
    staticClass: "mb-3"
  }), _c('iframe', {
    attrs: {
      "src": "https://player.twitch.tv/?channel=wirforce",
      "frameborder": "0",
      "allowfullscreen": "true",
      "scrolling": "no",
      "width": _vm.iframeW,
      "height": _vm.iframeH
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "2px 0px 4px",
      "display": "block",
      "width": "345px",
      "font-weight": "normal",
      "font-size": "10px",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.twitch.tv/wirforce?tt_medium=live_embed&tt_content=text_link"
    }
  }, [_vm._v("在 www.twitch.tv 觀賞 wirforce 的實況。")])]), _c('div', {
    staticClass: "mb-10"
  }), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("wirforce_byoc")]), _c('div', {
    staticClass: "mb-3"
  }), _c('iframe', {
    attrs: {
      "src": "https://player.twitch.tv/?channel=wirforce_byoc",
      "frameborder": "0",
      "allowfullscreen": "true",
      "scrolling": "no",
      "width": _vm.iframeW,
      "height": _vm.iframeH
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "2px 0px 4px",
      "display": "block",
      "width": "345px",
      "font-weight": "normal",
      "font-size": "10px",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.twitch.tv/wirforce_byoc?tt_medium=live_embed&tt_content=text_link"
    }
  }, [_vm._v("在 www.twitch.tv 觀賞 wirforce_byoc 的實況。")])])], 1), _c('section'), _c('div', {
    staticClass: "mb-60"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b034ff"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onAir.vue
// module id = 556
// module chunks = 1